// Vue
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import pathify from 'vuex-pathify'
import {dispatch} from 'vuex-pathify'

// Modules
import {getSettingData, getStores} from "@/api/api";
import {getAdditions, getCommodities} from "@/api/commodity";

Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [
    pathify.plugin,
  ],
  state: {
    isInit: false,
    settingData: null,
    additions: null,
    isLoading: false,
    mainCommodityCount: 0,
  },
  mutations: {
    setInit(state, payload) {
      state.isInit = payload
    },
    setSettingData(state, payload) {
      state.settingData = payload
    },
    setAdditions(state, payload) {
      state.additions = payload
    },
    setIsLoading(state, payload) {
      state.isLoading = payload
    },
    setMainCommodityCount(state, payload) {
      state.mainCommodityCount = payload
    },
  },
  actions: {
    init: async ({commit, dispatch}) => {
      dispatch('initSetting');

      commit('setMainCommodityCount', 0);

      commit('setInit', true);
    },
    async initSetting({commit}) {
      try {
        let settingData = await getSettingData();
        commit('setSettingData', settingData.data);
        // console.log(settingData.data);
      } catch (e) {
        console.log('error :', e);
      }
    },
    setMainCommodityCount: ({ commit }, count) => {
      commit('setMainCommodityCount', count);
    },
    showLoading({commit}) {
      commit('setIsLoading', true)
    },
    hideLoading({commit}) {
      commit('setIsLoading', false)
    },
  },
  getters: {
    isInit(state) {
      return state.isInit === true
    },
    getSettingData(state) {
      return state.settingData;
    },
    getAdditions(state) {
      return state.additions;
    },
    isLoading(state) {
      return state.isLoading;
    },
    getMainCommodityCount(state) {
      return state.mainCommodityCount;
    },
  },
})

// store.subscribe(mutation => {
//   if (mutation.type.startsWith('user/')) {
//     store.dispatch('user/update', mutation)
//   }
// })

store.dispatch('init')

export default store

export const ROOT_DISPATCH = Object.freeze({root: true})
